var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"invoice-template-editor-modal",attrs:{"body-class":"pt-0","size":"lg","hide-footer":"","title":_vm.modal_title}},[_c('InvoiceTemplateEditor',{attrs:{"template":_vm.template},on:{"update:template":_vm.update_template,"create:template":_vm.create_template,"preview:template":_vm.preview_template,"cancel":_vm.hide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }